import { z } from "zod";
import { LandModule, ModuleShared } from "@typedefs/modulesInterfaces";
import {
	landModuleSchema,
	mainModuleBaseSchema,
	moduleSharedSchema,
	moduleTypeObjectSchema,
	nullableNumber,
} from "@typedefs/zodSchemas";
/** Zod schema for validating land use change module API responses - extends ModuleShared + LandModule */
export const landUseChangeResponseSchema = mainModuleBaseSchema
	.extend(moduleSharedSchema.shape)
	.extend(landModuleSchema.shape)	
	.extend({
		id: z.number().optional(),
		module_type: z
			.number()
			.nullable()
			.or(moduleTypeObjectSchema)
			.optional(),
		created_at: nullableNumber.optional().or(z.string()),
		updated_at: nullableNumber.optional().or(z.string()),
		is_fire_used_start: z.boolean().optional(),
		is_fire_used_w: z.boolean().optional(),
		is_fire_used_wo: z.boolean().optional(),
		dry_matter_start: nullableNumber.optional(),
		dry_matter_w: nullableNumber.optional(),
		dry_matter_wo: nullableNumber.optional(),
		module_type_start: nullableNumber.optional(),
		module_type_w: nullableNumber.optional(),
		module_type_wo: nullableNumber.optional(),
	});

/** Inferred type from landUseChangeResponseSchema - use for validated API responses */
// export type LandUseChangeResponseInferred = z.infer<typeof landUseChangeResponseSchema>;

export interface LandUseChangeResponse extends ModuleShared, LandModule {
	id: number | undefined;
	module_type: number | null;
	created_at: string | null;
	updated_at: string | null;

	is_fire_used_start: boolean; //inutile
	is_fire_used_w: boolean;
	is_fire_used_wo: boolean;
	dry_matter_start: number | null; //inutile
	dry_matter_w: number | null;
	dry_matter_wo: number | null;
	module_type_start: number | null;
	module_type_w: number | null;
	module_type_wo: number | null;
}

export interface LandUseChangePayload extends ModuleShared, LandModule {
	id: number | undefined;

	is_fire_used_w: boolean;
	is_fire_used_wo: boolean;
	dry_matter_w: number | null;
	dry_matter_wo: number | null;
	module_type_start: number | null;
	module_type_w: number | null;
	module_type_wo: number | null;
}

export interface ModuleFull {
	module: LandUseChangeResponse;
}
